import React from 'react';
import { Link, useSearchParams } from 'react-router';
import { AccessError } from '@/types/errors';
import { PageRequest } from '@/route-handlers/page-request';
import { CheckCookie } from '@/connections/auth';
import { OptionalComponent } from '@ui/optional-component/optional-component';
import { getErrorConfig } from '@/utils/errors/errors';

const ErrorComponent = (): React.JSX.Element => {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  const { message, showRecheckSession } = getErrorConfig(error as AccessError);
  // Should drop the error param from the search params
  const params = PageRequest.fromSearchParams(searchParams);

  const handleCheckCookie = async () => {
    await CheckCookie();
  };

  return (
    <>
      <div className="form-page-container flex-center flex-column">
        <h1>😵‍💫</h1>
        <h3>Uh oh!</h3>
        <p>{message}</p>
        <OptionalComponent display={showRecheckSession}>
          <button className="button auth-resource-link primary" onClick={handleCheckCookie}>
            Recheck session
          </button>
        </OptionalComponent>
        <Link to={`/logout?${params.toParams()}`} className="button text-center">
          Logout
        </Link>
      </div>
    </>
  );
};

export default ErrorComponent;
